import {writable} from 'svelte/store';

const store = writable({
    user_id: null
});
export default store;
